<template>
  <div class="product">
    <div class="productContent">
      <div class="productImage" v-bind:style="{ backgroundImage: `url(${productImage})` }"></div>
      <div class="productInfo">
        <p class="productInfo__innerWrapper">
          <span class="productInfo__priceLabel">{{
        content.labels.TotalsText
      }}</span>
          <span class="productInfo__priceAmount" v-if="price != 0">
            {{ content.labels["PrePriceText"] }}
            <span class="-relative">
              <span :class="{ '-loading': content.loading > 0 }"></span>
              <span :style="[content.loading > 0 && { color: 'transparent' }]">{{ price }}</span>
            </span>
          </span>
          <span class="productInfo_priceAmount" v-if="price === 0">{{
        content.labels["StaticPriceForNoneDefaultProduct"]
      }}</span>
        </p>
        <p v-show="content.labels && content.labels.VatText" class="productInfo__priceVatLabel">
          {{ content.labels.VatText }}
        </p>
        <p v-show="content.labels && content.labels['PriceDisclaimer']" class="productInfo__priceDisclaimer">
          {{ content.labels["PriceDisclaimer"] }}
        </p>
      </div>
      <div class="productDetails">
        <!--
        <h4>{{ content.labels['MandatorySectionTitle'] }}</h4>
        -->
        <ul>
          <li>
            <div class="productDetails__info">
              <div v-if="filledOutSteps.length > 0">
                <ul>
                  <li v-if="content.product">
                    <span class="productDetails__infoLabel">{{
        content.labels.ProductIdLabel
      }}</span>
                    <span class="productDetails__infoText">{{
          content.product.Id
        }}</span>
                  </li>
                  <li :key="index" v-for="(step, index) in filledOutSteps">
                    <span class="productDetails__infoLabel">{{
        step.Title
      }}</span>
                    <span class="productDetails__infoText">
                      {{
          step.selectedOption
            ? step.Options.find(opt => {
              return opt.Id == step.selectedOption.Id;
            }).Title
            : ""
        }}
                    </span>
                  </li>
                </ul>
              </div>

              <!--
              <div v-if="content.additionalProds">
                <h4>##Additional products##</h4>
                <div class="m-additional__selected">
                </div>
                <ul>
                  <li :key="index" v-for="(prod, index) in content.additionalProds">
                    <div class="m-additional" v-if="prod">
                      <div class="m-additional__action">
                        <input type="radio" v-model="additional" />
                      </div>
                      <div class="m-additional__info">
                        <span>{{ prod.DisplayName }}</span>
                        <span>{{ prod.Id }}</span>
                        <span>##Additional product info##</span>
                        <span>{{ formatPrice(prod.PriceIncVat) }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              -->
            </div>
          </li>
        </ul>
      </div>
      <div class="productActions">
        <button class="-arrow" :disabled="!content.product" @click="addToBasket
        ">
          {{ content.labels["AddToBasketText"] }}
        </button>
        <!--
        <button @click="sendMail = !sendMail">{{ content.labels['EmailButtonText'] }}</button>



        <div class="m-priceCalculator__emailForm" v-if="sendMail == true">
          <form @submit="checkEmailForm">
            <input type="text" v-model="emailName" :placeholder="[content.labels['EmailFieldPlaceholderName']]" />
            <input
              type="email"
              v-model="emailAddress"
              :placeholder="[content.labels['EmailFieldPlaceholderEmail']]"
            />
            <label
              ><input type="checkbox" v-model="emailTerms" />{{ content.labels['EmailCheckbox1Text'] }}</label
            >
            <ul v-if="emailErrors" class="emailErrors">
              <li :key="index" v-for="(error, index) in emailErrors">
                <span>&#9888;</span> {{ error }}
              </li>
            </ul>
            <button>{{ content.labels['EmailButtonTextSend'] }}</button>
          </form>
        </div>
        -->
        <!--
        <button class="-text" @click="reset">{{content.labels['ReloadButtonText']}}</button>
        -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  props: ["content"],
  data() {
    return {
      sendMail: false,
      emailErrors: [],
      emailName: null,
      emailAddress: null,
      emailTerms: false,
      additional: null
    };
  },
  computed: {
    price() {
      if (this.content.product) {
        // TODO: Get language code from BE
        return this.formatPrice(
          this.content.isVatIncluded
            ? this.content.product.PriceIncVat
            : this.content.product.PriceExVat
        );
      } else {
        return 0;
      }
    },
    filledOutSteps() {
      return this.content.steps.filter(s => {
        return s.selectedOption;
      });
    },
    productImage() {
      //This is not part of the PBI
      /*
      let windowStr = "GGL";
      if (this.content.product) {
        windowStr = this.content.product.Id.replaceAll(
          this.content.product.TypeSignSize + " ",
          ""
        ).replaceAll(" ", "-");
      }
      return `/-/media/roofwindowshop/productimages/outside/windows/${windowStr}.png`;
      */

      return this.content.prodImg;
    }
  },
  methods: {
    formatPrice(val) {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: this.content.product.Currency
      }).format(val);
    },
    // GA4 tracking
    configuratorStartsEvent() {
      var dataLayer = window.dataLayer || [];

      const now = new Date();
      const timestamp = `${now
        .toISOString()
        .slice(0, 10)} ${now.toTimeString().slice(0, 8)}.${now
          .getMilliseconds()
          .toString()
          .padStart(3, "0")}`;

      var isEventPresent = window.dataLayer.some(function (obj) {
        return obj.event === "configurator_starts_ga4";
      });

      if (!isEventPresent) {
        dataLayer.push({
          event: "configurator_starts_ga4",
          timestamp: timestamp,
          site_section: "Main configurator"
        });
      }
    },
    addToBasket() {
      this.$emit("add-to-basket");
      this.configuratorStartsEvent();
    },
    reset() {
      this.$emit("reset");
    },
    checkEmailForm(e) {
      if (this.emailName && this.emailAddress && this.emailTerms) {
        // Send email
      }

      this.emailErrors = [];

      if (!this.emailName) {
        this.emailErrors.push("##Name required##");
      }

      if (!this.emailAddress) {
        this.emailErrors.push("##Email required##");
      }

      if (!this.emailTerms) {
        this.emailErrors.push("##Check terms##");
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../style/_vars";

.product {
  width: 100%;

  @include respond-above(sm) {
    width: 33.3333333%;
  }

  position: relative;

  &Content {
    @include respond-above(sm) {
      margin: 0 0 0 3.1rem;
    }

    position: sticky;
    top: 0.5rem;
  }

  &Image {
    padding: 1rem;
    margin-bottom: 0.5rem;
    text-align: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
  }

  &Info {
    background: $colorLightGray;
    margin-bottom: 0.5rem;
    padding: 1rem 1rem;
    font-weight: bold;
    font-size: 1rem;

    p {
      margin: 0;
    }

    &__priceVatLabel {
      font-weight: normal;
    }

    &__innerWrapper {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-bottom: 0;
    }

    &__price {
      &Amount {
        display: inline-flex;
        float: right;
        padding-bottom: 0.2rem;
      }

      &Label {
        padding-bottom: 0.2rem;
      }

      &Disclaimer {
        font-size: 0.7rem;
        color: gray;
        text-align: right;
        font-weight: normal;
        padding-top: 0.5rem;
        clear: both;
      }
    }
  }

  &Details {
    padding: 0.5rem 1rem;
    background: $colorLightGray;

    ul {
      list-style: none;
      padding: 0;
    }

    h4 {
      border-bottom: 1px solid black;
    }

    &__info {
      &Label {
        font-weight: bold;
        font-size: 0.75rem;
        display: block;
        margin-bottom: 0.2em;
      }

      &Text {
        display: block;
        font-size: 0.75rem;
        margin-bottom: 1em;
        color: gray;
      }
    }
  }

  &Actions {
    padding: 0.5rem 0;

    input {
      max-width: 100%;
      box-sizing: border-box;
    }
  }
}

button {
  padding: 1em 0.9em;
  display: block;
  color: white;
  text-align: left;
  border: 0;
  background: #476996;
  width: 100%;
  margin-bottom: 0.5rem;
  cursor: pointer;

  &:disabled {
    background: gray;

    &:hover {
      background: darkgray;
    }
  }

  &:hover {
    background: #5d82b3;
  }

  &.-text {
    background: none;
    text-align: left;
    color: black;
    padding-left: 0;
    padding-right: 0;
  }

  &.-arrow {
    &:after {
      content: "";
      display: inline-block;
      float: right;
      width: 0.5em;
      height: 0.5em;
      margin-top: 0.2em;
      border-bottom: 0.25em solid white;
      border-right: 0.25em solid white;
      transform: rotate(-45deg);
    }
  }
}

input[type="text"],
input[type="email"] {
  padding: 0.6em;
  border: 0;
  display: block;
  margin-bottom: 0.5rem;
}

.emailErrors {
  li {
    display: inline-block;
    margin-right: 2em;
    padding: 0;
    background: orange;
    border-radius: 3px;
    color: white;
    padding: 0.5em 1em;
  }
}

.m-additional {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 1rem;

  &__action {
    flex: 0;
    width: auto;
    padding-right: 1em;
    padding-top: 0.5em;
  }

  &__info {
    flex: 1 1 0;
    width: auto;
    border-top: 1px solid gray;

    span {
      display: block;
      border-top: 1px solid gray;
      padding: 0.5rem 0;
    }
  }
}
</style>
